function ContactPage() {
  return (
    <div>
      <h2>Kontakt</h2>
      <p>
        Manuel Seibel
        <br />
        <a href="mailto:vorstand@kanuverein-suew.de">
          mailto:vorstand@kanuverein-suew.de
        </a>
      </p>
    </div>
  );
}

export default ContactPage;
